import { Box, styled } from '@mui/material';
import { useEffectOnce } from 'react-use';
import {
  TrackHomePageEvent,
  useTrackHomePageAnalytics,
} from '$analytics/useTrackAnalytics/domains/homePage';
import { FactsAndFigures } from './components/FactsAndFigures';
import { NeedsAttention } from './components/NeedsAttention';
import { QuickLinks } from './components/QuickLinks';
import { SideListings } from './components/SideListings';
import { TransactionSearchLastViewed } from './components/TransactionSearchLastViewed';
import { WelcomeContainer } from './components/WelcomeContainer';

const HomeContainer = styled(Box)`
  overflow-y: auto;
  overflow-x: hidden;
`;

export function Home() {
  const trackEvent = useTrackHomePageAnalytics();

  useEffectOnce(() => {
    trackEvent(TrackHomePageEvent.HomePageLanding);
  });

  return (
    <HomeContainer>
      <WelcomeContainer />
      <NeedsAttention />
      <TransactionSearchLastViewed />
      <QuickLinks />
      <SideListings />
      <FactsAndFigures />
    </HomeContainer>
  );
}
